// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19N3C","label":"styles_label__3Mqsc"};